<template>
  <modal-layout :add-class="addClass">
    <popup-cancel-order
      :order-info="orderInfo"
      @dispose="onDispose"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
    <modal-alert ref="refModalAlert" />
  </modal-layout>
</template>
<script>
import ModalLayout from '@/components/global/ModalLayout.vue';
import modalMixin from '@/components/global/modal-mixin';
import { log } from '@/utils/common';
import orderApi from '@/apis/order';
import ModalAlert from '@/components/global/ModalAlert.vue';
import PopupCancelOrder from './PopupCancelOrder.vue';

export default {
  name: 'ModalCancelOrder',
  components: {
    ModalLayout,
    PopupCancelOrder,
    ModalAlert,

  },
  mixins: [modalMixin],
  props: {
    orderInfo: {
      type: Object,
      default: () => {},
    },
    orderKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {

    };
  },
  computed: {
    addClass() {
      return this.orderInfo.group_order_yn == 'Y' ? 'type-b' : '';
    }
  },
  watch: {

  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    onBeforeDispose() {
      log('ModalCancelOrder::onBeforeDispose', 'before-dispose');
    },
    async onConfirm() {
      log('ModalCancelOrder::onConfirm', 'confirmed', this.orderKey);
      const r = await orderApi.cancelPayment(this.orderKey);
      if (r.code !== 0) {
        await this.$refs.refModalAlert.openWithMessage(r.returnMessage);
        return;
      }
      log('ModalCancelOrder::onConfirm', r);
      this.$emit('confirm');
      this.close();
    },
    onCancel() {
      log('ModalCancelOrder::onCancel', 'not confirmed');
    },
    proceedCancelOrder() {
      log('ModalCancelOrder::proceedCancelOrder', 'processing cancel order..');
    },
  },
};
</script>
